<template>
  <table class="views-chart-table">
    <tr>
      <td class="views-chart-table__date-time-header">
        {{dateTimeTitle}}
      </td>
      <td class="views-chart-table__views-header">
        {{$t('feed.audit.edit.ViewsTable.views')}}
      </td>
    </tr>

    <tr v-for="(item, index) in viewsData" :key="index">
      <td class="views-chart-table__date-time">
        {{item[0]}}
      </td>
      <td
        class="views-chart-table__value"
        contenteditable="true"
        @keyup.enter="onEnter($event)"
        @blur="updateChartItem($event, index)"
      >
        {{item[1]}}
      </td>
    </tr>
  </table>
</template>

<script>
  import { UPDATE_AUDIT_CHART } from "../../../../../store/actions/audit";

  export default {
    name: "ViewsTable",
    props: {
      data: {
        type: Object
      },
      chartName: {
        type: String
      }
    },
    computed: {
      dateTimeTitle() {
        return this.data.graph_data[0][0].includes("-") ? this.$t('feed.audit.edit.ViewsTable.date') : this.$t('feed.audit.edit.ViewsTable.time');
      },
      viewsData() {
        return this.data.graph_data;
      }
    },
    methods: {
      onEnter(event) {
        event.target.blur();
      },
      updateChartItem(event, index) {
        const value = parseInt(event.target.innerHTML.trim());
        event.target.innerHTML = value;

        this.$store.dispatch(UPDATE_AUDIT_CHART, {
          chart: this.chartName,
          value,
          index
        })
          .then(() => {
            this.$notify({
              title: this.$t('feed.audit.edit.notify.title'),
              message: this.$t('feed.audit.edit.notify.text'),
              type: 'success',
              duration: 1500,
              showClose: false
            });
          });
      }
    }
  }
</script>

<style>
  .views-chart-table {
    width: 100%;
    margin-top: 34px;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    border-collapse: collapse;
  }

  .views-chart-table td {
    height: 40px;
    padding: 0 0 0 20px;
    border: 2px solid #EBEBEB;
    box-sizing: border-box;
  }

  .views-chart-table .views-chart-table__date-time-header {
    width: 40%;
    color: #5E6D82;
    border-left: transparent;
  }

  .views-chart-table__views-header {
    width: 60%;
    color: #5E6D82;
    cursor: default;
  }

  .views-chart-table .views-chart-table__views-header {
    border-right: transparent;
  }

  .views-chart-table .views-chart-table__value {
    border-right: transparent;
  }

  .views-chart-table .views-chart-table__date-time {
    border-left: transparent;
  }

  .views-chart-table__date-time,
  .views-chart-table__value {
    color: #5E6D82;
  }

  .views-chart-table__value {
    cursor: text;
  }

  .views-chart-table__value:hover {
    background-color: #f5f7fa;
  }

  .views-chart-table__value:focus {
    outline: none;
    background-color: #f5f7fa;
  }
</style>
